export default {
  state: {
    alertState: {
      active: false,
      message: ''
    }
  },
  mutations: {
    setAlertState (state, payload) {
      state.alertState = payload
    }
  },
  actions: {
    setAlertState  ({commit}, payload) {
      commit('setAlertState', payload)
    }
  },
  getters: {
    alertState (state) {
      return state.alertState
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/alertState.js